import { useHistory, useRouteMatch } from 'react-router-dom';

import AssignmentIcon from '@mui/icons-material/Assignment';
import SearchIcon from '@mui/icons-material/Search';
import { IconButton, Stack, TableCell, TableRow, Tooltip } from '@mui/material';
import { styled } from '@mui/styles'

const StyledTableRow = styled(TableRow)(() => ({
  '&:nth-of-type(odd)': {
    backgroundColor: '#fafafa',
  },
}));

const StyledTableCell = styled(TableCell)(() => ({
  color: '#4B4B4B',
}));

export interface IHistoricRow {
  historic: IHistoric;
}

type IHistoric = {
  createAt: string;
  tutorName: string;
  petName: string;
  consult: {
    consultType: string;
  };
};

export enum ConsultTypeEnum {
  'teleorientation' = 'Teleorientação',
  'teleconsultation' = 'Teleconsulta',
}

export const HistoricRow: React.FC<IHistoricRow> = ({ historic }) => {
  const { path } = useRouteMatch();
  const history = useHistory();

  const handleViewHistoricPet = () => {
    history.push(`${path}/historicPet`);
  };

  return (
    <StyledTableRow>
      <TableCell component="th" scope="row" sx={{ color: '#4B4B4B' }}>
        {/* {maskDate(historic?.createAt)} */}
        {historic?.createAt}
      </TableCell>

      <StyledTableCell>{historic?.tutorName}</StyledTableCell>

      <StyledTableCell>{historic?.petName}</StyledTableCell>

      <StyledTableCell>{historic?.consult?.consultType}</StyledTableCell>
      {/* {historic?.consult?.consultType &&
        ConsultTypeEnum[
          historic?.consult
            ?.consultType as unknown as keyof typeof ConsultTypeEnum
        ]} */}

      <TableCell align="right">
        <Stack flexDirection="row" justifyContent="flex-end">
          {historic?.consult?.consultType === 'Teleconsulta' && (
            <Tooltip title="Ver prescrição">
              <IconButton color="inherit" onClick={() => {}}>
                <AssignmentIcon />
              </IconButton>
            </Tooltip>
          )}
          <Tooltip title="Ver mais">
            <IconButton
              aria-label="edit"
              color="inherit"
              onClick={handleViewHistoricPet}
            >
              <SearchIcon />
            </IconButton>
          </Tooltip>
        </Stack>
      </TableCell>
    </StyledTableRow>
  );
};

